/*
 * CopyModal Messages
 *
 * This contains all the text for the ConfirmationBox component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.ConfirmationBox';

export default defineMessages({
  selectPlace: {
    id: `${scope}.selectPlace`,
    defaultMessage: 'Select a place to paste',
  },
});
